export const ensureDate = (value: unknown): Date => {
	try {
		switch (typeof value) {
			case 'undefined':
			case 'boolean':
			case 'function':
			case 'symbol':
			case 'bigint':
				break
			case 'object':
				if (value instanceof Date) return new Date(value)
				break
			case 'number':
			case 'string':
				return new Date(value)
		}
	} catch (e) {}
	console.error('failed to parse date object', value)
	return new Date()
}
